export const blockIconsHomeBatteryHoriz050New = (
	<span className='material-symbols-outlined'>battery_horiz_050</span>
);
